export const AllowPay = (STOPDATE) => {
    console.log(":sdfsdf");
    let [day, month, year] = STOPDATE.split("/");
    if (parseInt(year) > 2400) {
      year = (parseInt(year) - 543).toString();
    }
    const textDate = `${month}/${day}/${year} 23:59`;
    const enddate = new Date(textDate);
    const datenow = new Date();
    if (datenow > enddate) {
      console.log(datenow);
      console.log("มากกว่า");
      console.log(enddate);
      return true;
    } else {
      console.log(datenow);
      console.log("น้อยกว่า");
      console.log(enddate);
      return false;
    }
  };


  export  const PrintRegist = (ROB_ID, MAJOR_ID, DataRegister) => {
    let textDate = "12/12/2028 23:00";
    if (ROB_ID === "152") {
      textDate = `12/12/2028 09:00`;
    } else if (ROB_ID === "153" || ROB_ID === "155") {
      if (
        MAJOR_ID === "1202" ||
        MAJOR_ID === "1207" ||
        MAJOR_ID === "1208" ||
        MAJOR_ID === "1301" ||
        MAJOR_ID === "1110" ||
        MAJOR_ID === "1304" ||
        MAJOR_ID === "1310"
      ) {
        textDate = `12/12/2024 09:00`;
      } else {
        textDate = `12/27/2024 18:00`;
      }
    } else if (ROB_ID === "151") {
      if (MAJOR_ID === "8201") {
        textDate = `01/31/2025 09:00`;
      } else {
        textDate = `03/18/2025 18:00`;
      }
    } else if (ROB_ID === "154") {
      textDate = `04/25/2025 18:00`;
    } else if (ROB_ID === "152") {
      textDate = `04/25/2024 18:00`;
    } else if (ROB_ID === "156" || ROB_ID === "159" || ROB_ID === "157" || ROB_ID === "158") {
      if (ROB_ID === "157" || ROB_ID === "158") {
        if (
          DataRegister[0].Major1_MAJOR_ID === "1202" ||
          DataRegister[0].Major1_MAJOR_ID === "1207" ||
          DataRegister[0].Major1_MAJOR_ID === "1208" ||
          DataRegister[0].Major1_MAJOR_ID === "1110"
        ) {
          textDate = `02/14/2025 10:00`;
        } else {
          textDate = `02/14/2028 10:00`;
        }
      } else {
        textDate = `02/14/2025 10:00`;
      }
    } else if (ROB_ID === "160") {
      textDate = `04/14/2025 18:00`;
    } else if (ROB_ID === "161") {
      textDate = `04/14/2025 18:00`;
    } else if (ROB_ID === "164") {
      textDate = `05/13/2025 18:00`;
    } else if (ROB_ID === "169") {
      textDate = `08/18/2025 18:00`;
    } else if (ROB_ID === "170") {
      textDate = `08/18/2025 18:00`;
    } else if (ROB_ID === "171") {
      textDate = `09/11/2025 18:00`;
    } else {
      textDate = `12/12/2025 18:00`;
    }
    const start = new Date(textDate);
    const datenow = new Date();
    if (datenow > start) {
      return false;
    } else {
      return true;
    }
  };